import { useQuery } from "@tanstack/react-query";
import { getFetch } from "../utils/api";

export type ContactLink = {
  href: string;
  title: "Phone" | "Email" | "LinkedIn" | "Url";
};

export type ContactData = {
  name: string;
  title: string;
  photo: string;
  vcard: string;
  contactLinks: ContactLink[];
  bio: string;
  homepageUrl: string;
};

type ContactResponse = {
  oneContact: ContactData;
};

export const useGetOneContact = (name: string) => {
  return useQuery({
    queryKey: ["contact", name],
    queryFn: () => getFetch<ContactResponse>(`team/${name}`),
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 3,
    enabled: !!name, // Only fetch if name is provided
  });
};
